import api from "./client";

/* Compliance & Credentials — bound to compliance_app.
   Contract of record: COMPLIANCE_ENDPOINT_CONTRACT_2026-09-07.md (lane D).
   All three routes verified live on os.abon.ai 2026-09-07.
   Base: /api/compliance/. Reads: any tenant member. Writes: admin/owner/manager. */

// GET 200 — the whole screen in one call: requirements (checklist, derived from
// industry + jurisdiction), held credentials, advisory flags, expiry risks,
// and the alerts opt-in. If requirements.needs_jurisdiction is true, prompt
// for state first.
export const getComplianceOverview = (params = {}) =>
  api.get("/compliance/overview/", { params });

// GET 200 — { jurisdiction: "FL"|null, expiry_alerts_enabled: bool }
export const getComplianceSettings = (params = {}) =>
  api.get("/compliance/settings/", { params });

// POST 200 — body may carry either/both: { jurisdiction, expiry_alerts_enabled }.
// jurisdiction: 2-letter state (drives the requirement pack); "" clears it.
export const updateComplianceSettings = (body = {}) =>
  api.post("/compliance/settings/", body);

// POST 200 — enter/confirm a credential. Idempotent on tenant+type_key+holder,
// so re-POSTing edits. number/expiry are TYPED by the owner, never guessed.
// Errors: 400 unknown_type | 400 holder_required | 403 (not admin).
export const upsertCredential = (body = {}) =>
  api.post("/compliance/credentials/", body);

// Document-first intake (lane D, compliance_app.CredentialExtractView): upload the license PDF,
// D stores it (StoredFile/S3) and runs the Bedrock document extractor, and returns a PROPOSED
// credential shaped like the confirm body — nothing is written until the admin confirms via
// upsertCredential(). 404 until D's build is deployed; the UI degrades to the typed form.
export const extractCredential = (file, { type_key, holder_tech_id } = {}) => {
  const form = new FormData();
  form.append("file", file);
  form.append("type_key", type_key || "");
  if (holder_tech_id != null) form.append("holder_tech_id", String(holder_tech_id));
  return api.post("/compliance/credentials/extract/", form, { headers: { "Content-Type": "multipart/form-data" } });
};
